import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findMessages = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_MESSAGING_API_URL}/messages${query}`,
    {
      headers,
    },
  );
};

export const findMessageById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MESSAGING_API_URL}/messages/${id}`,
    {
      headers,
    },
  );
};

export const deleteMessage = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_MESSAGING_API_URL}/messages/${id}`,
    {
      headers: headers,
    },
  );
};

export const deleteMessages = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_MESSAGING_API_URL}/messages?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
